import { useIonModal, isPlatform } from '@ionic/react'
import { useContext, useEffect, useRef, useState } from 'react'
import Context from '../context'
import { enterAnimationLeft, leaveAnimationLeft } from '../utils/modal-animations'
import { StoreDetailsFlyout } from './StoreDetailsFlyout'

/* eslint-disable no-unused-vars */
export enum MarkerType {
  highlighted = '/images/map-icons/selected.svg',
  selected = '/images/map-icons/highlighted.svg',
  standard = '/images/map-icons/standard.svg'
}
/* eslint-disable no-unused-vars */

const StoresMap = ({ center, stores = [], selectedStoreId = '', onStoreClick }) => {
  const { state } = useContext(Context)
  const ref = useRef(null)

  const [openStoreDetails, setOpenStoreDetails] = useState(null)

  const handleDismissStoreDetails = () => {
    dismissStoreDetails()
  }

  const [presentStoreDetails, dismissStoreDetails] = useIonModal(StoreDetailsFlyout, { dismiss: handleDismissStoreDetails, store: openStoreDetails })

  useEffect(() => {
    if (state.googleLoaded && ref) {
      const map = new window.google.maps.Map(ref.current, {
        zoom: center?.state ? 7 : (isPlatform('mobile') ? 9 : 11),
        center: center || { lat: state.cart.store?.latitude, lng: state.cart.store?.longitude },
        gestureHandling: 'cooperative'
      })

      for (const store of stores) {
        const { name, latitude, longitude, storenumber } = store
        const googleMapsMarker = new window.google.maps.Marker({
          position: { lat: latitude, lng: longitude },
          map,
          title: store.city,
          clickable: true,
          icon: storenumber === state.cart.store?.storenumber ? MarkerType.highlighted : storenumber === selectedStoreId ? MarkerType.selected : MarkerType.standard
        })
        googleMapsMarker.addListener('click', () => {
          setOpenStoreDetails(store)
          presentStoreDetails({ cssClass: 'modal--store__flyout', enterAnimation: enterAnimationLeft, leaveAnimation: leaveAnimationLeft })
          onStoreClick(storenumber)
        })
      }
    }
  }, [state.googleLoaded, ref, stores, center, selectedStoreId, state.cart.store])

  return <div className='stores-map' ref={ref} />
}

export default StoresMap
